import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'

import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Image } from '@/components/atoms/Image/Image'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import AdvBgImage2 from '@/assets/icons/advatages-grid-item-bg-2.svg'
import AdvBgImage from '@/assets/icons/advatages-grid-item-bg.svg'
import { AdvantagesGridTypes } from './types'

export function AdvantagesGrid({ grid }: AdvantagesGridTypes) {
  return (
    <section className="mx-auto max-w-screen-desktop py-32 tablet:py-64 px-24 laptop:px-90 overflow-hidden flex flex-col gap-96 laptop:gap-144">
      {grid.map(({ title, heading, description = '', image, image_description, reverse, cta_button }, index) => (
        <div
          key={title}
          className={clsx(
            'flex flex-col-reverse netbook:flex-row netbook:!items-center',
            reverse ? 'netbook:flex-row-reverse netbook:justify-between' : 'netbook:justify-between'
          )}
          id={kebabCase(title)}
        >
          <div
            className={clsx(
              'relative w-full netbook:w-1/2 netbook:max-w-34 flex flex-col px-20 py-28 tablet:p-36 bg-white rounded-xl tablet:rounded-3xl shadow-xl self-start mt-20 netbook:my-auto'
            )}
          >
            {/* Background dots */}
            {index % 2 === 0 && (
              <img className="absolute w-28 -left-8 -top-8 -z-1" src={AdvBgImage2} alt="adventages-bg" />
            )}
            {index % 2 !== 0 && (
              <img className="w-full absolute -right-40 -top-28 -z-1" src={AdvBgImage} alt="adventages-bg" />
            )}
            <p className="font-poppins text-h4mobile netbook:text-xxl font-bold mb-12 text-left">{image_description}</p>
            <Image fixed={false} fluid data={image} options={{ width: 500 }} />
          </div>
          <div
            className={clsx(
              'w-full netbook:w-1/2 flex flex-col netbook:mb-0 netbook:max-w-34',
              reverse ? 'netbook:mr-40' : 'netbook:ml-40'
            )}
          >
            <p
              className="text-preheader netbook:self-start font-poppins
            text-primary-500 tracking-wide uppercase font-bold mb-24 text-left"
            >
              {heading}
            </p>
            <h2
              className="text-text-dark-900 text-left netbook:self-start text-headingS-mobile netbook:text-headingS
            font-bold font-poppins mb-24"
            >
              {title}
            </h2>
            <div className="advantages-grid-description text-bodyM text-text-dark-900 netbook:text-bodyL netbook:w-full mb-16 netbook:max-w-lg leading-30">
              <RichTextField data={description} />
            </div>
            {cta_button.length > 0 && (
              <CustomLink {...cta_button[0]} className="flex items-center">
                <p className="text-bodyL font-bold text-primary-500 hover:text-primary-400">{cta_button[0].text}</p>
                <i className="fa fa-long-arrow-right text-primary-500 hover:text-primary-400 ml-8" />
              </CustomLink>
            )}
          </div>
        </div>
      ))}
    </section>
  )
}
